"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
const TableHeaderCell = _ref => {
  let {
    column
  } = _ref;
  const headerComponent = _react.default.useMemo(() => {
    const columnInfoHeader = column.headerComponent;
    return (0, _ark.isDefined)(columnInfoHeader) ? columnInfoHeader : null;
  }, [column]);
  return /*#__PURE__*/_react.default.createElement("th", {
    className: (0, _arkReact.concatClassName)('tableHeaderCol', column.className)
  }, headerComponent !== null ? headerComponent : column.accessor);
};
process.env.NODE_ENV !== "production" ? TableHeaderCell.propTypes = {
  column: _propTypes.default.any
} : void 0;
TableHeaderCell.defaultProps = {
  column: undefined
};
var _default = exports.default = TableHeaderCell;